import React from "react";
import Breadcrumb from "../../common/Breadcrumb";
import ProjectWrapper from "./ProjectWrapper";

function ProjectsPage() {
  return (
    <>
      <Breadcrumb pageName="Projects" />
      <ProjectWrapper />
    </>
  );
}

export default ProjectsPage;
